<template>
  <div>
    <Nav :current="current"></Nav>
    <div class="content">
      <div class="title">添加系统</div>
      <div class="form">
        <div class="form_item">
          <span class="item_name"><span class="xing">*</span> 系统名称</span>
          <input type="text" v-model="name" />
        </div>
        <div class="form_item">
          <span class="item_name"><span class="xing">*</span>系统域名</span>
          <input type="text" v-model="url" /><span class="">例:https://xxx.com/a/a/</span>
        </div>
        <div class="form_item">
          <span class="item_name indent">是否设为默认系统</span>
          <div class="radio">
            <template>
              <el-radio v-model="defaultSystem" label=false>否</el-radio>
              <el-radio v-model="defaultSystem" label=true>是</el-radio>
            </template>
          </div>
        </div>
        <!-- <div class="form_item">
          <span class="item_name indent">是否设为主库</span>
          <div class="radio">
            <template>
              <el-radio v-model="ismaster" label=false>否</el-radio>
              <el-radio v-model="ismaster" label=true>是</el-radio>
            </template>
          </div>
        </div> -->
      </div>
    </div>
    <el-row class="el-row">
      <el-button
        type="primary"
        class="el-button btnSty"
        @click="addSystem"
        >保存</el-button
      >
      <el-button class="el-button btnret" @click="retSuper">返回</el-button>
    </el-row>
  </div>
</template>
<script>
import Nav from "@/components/Nav.vue";
import apiData from "@/config/api";
import http from "@/config/httpConfig";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      current: "公司后台",
      name:'',
      url:'',
      defaultSystem:'false',
      // ismaster: 'false',
    };
  },
  created() {},
  mounted() {},
  methods: {
    //添加角色
    addSystem() {
      let _this = this;
      let params = {
        name: _this.name,
        url:_this.url,
        defaultSystem: _this.defaultSystem,
        // ismaster: _this.ismaster,
      };
      
        http.post(apiData.systemAdd, true, params, function (res) {
          console.log(res);
          if (res.data.code == 200) {
            console.log(res.data.data)

            _this.$router.go(-1);
          } 
        });
   
     
    },
    retSuper() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped lang="less">
.content {
  text-align: left;
  .title {
    width: 100%;
    height: 56px;
    line-height: 56px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-indent: 10px;
    float: left;
  }

  .form {

    .form_item {
      display: flex;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-indent: 10px;

      input {
        width: 200px;
        height: 30px;
        margin-top: 5px;

        background: transparent;
        border: 1px solid rgb(204, 204, 204);
        text-indent: 10px;
      }

      .xing {
        color: #ffba1a;
      }
    }
    
    .item_name {
      width: 160px;
      display: block;
      color: #666;
      padding-left: 10px;
    }

    .form_item:nth-child(odd) {
      background: #f8f8f8;
    }
  }
}
.indent{
  font-size: 12px;
}
.el-row {
  text-align: center;
  height: 40px;
  width: 100%;
  margin: 200px 0;
}

.btnret:hover {
  background: #55c4b8;
  color: #f8f8f8;
  border: 1px solid #55c4b8;
}

.el-button {
  width: 200px;
  height: 40px;
  border: 1px solid #55c4b8;
  color: #55c4b8;
}

.btnSty {
  background: #55c4b8;
  color: #fff;
}
.btnSty:hover {
  background: #55c4b8;
  color: #fff;
  border: 1px solid #55c4b8;
}
</style>
